import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography
} from '@mui/material';

const DeleteAirflow = ({ open, closeModal, dagName, handleConfirm }) => {
    return (
        <Dialog open={open} onClose={closeModal} aria-labelledby="delete-dag-title" maxWidth="xs" fullWidth>
            <DialogTitle id="delete-dag-title">Xóa DAG</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Bạn có chắc muốn xóa DAG{' '}
                    <Typography component="span" fontWeight={600} color="primary.main">
                        {dagName}
                    </Typography>
                    ? Hành động này không thể hoàn tác.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={closeModal} color="inherit">
                    Hủy
                </Button>
                <Button variant="contained" color="error" onClick={handleConfirm}>
                    Xóa
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DeleteAirflow.propTypes = {
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    dagName: PropTypes.string,
    handleConfirm: PropTypes.func.isRequired
};

export default DeleteAirflow;
